import { IImage } from 'shared/models/media';

export interface IPOIInfo {
  id: string;
  name: string;
  type?: string;
  typeName?: string;

  placeId?: string;

  formattedAddress?: string;
  formattedAddressWithoutPostCountryAsc?: string;
  internationalPhoneNumber?: string;

  headerImage?: IImage;
}

export enum EPOIUnavailableReason {
  NOT_FOUND = 'not_found',
  SERVER_ERROR = 'server_error',
}

export interface IPOIUnavailableInfo {
  poiId: string;
  unavailableReason: EPOIUnavailableReason;
}

export type TPOIInfo = IPOIInfo | IPOIUnavailableInfo;

export const POIInfoUtil = {
  isAvailable: (poi: TPOIInfo): poi is IPOIInfo => {
    return !('unavailableReason' in poi);
  },
};
